import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { post, get, thunkHandler, put } from "../../helpers/base";

const initialState = {
  toneData: [],
  toneCount: 0,
  toneLoader: false,
};

export const getTone = createAsyncThunk("blog-services/tone/get", async (data, thunkAPI) => {
  const response = await thunkHandler(get("blog-services/tone/get", data), thunkAPI);
  if (response.success) {
    return response.payload;
  } else {
    return thunkAPI.rejectWithValue(response.message);
  }
});

export const addTone = createAsyncThunk("blog-services/tone/create", async (data, thunkAPI) => {
  let payload = {
    tone: data?.tone,
    description: data?.description,
  };
  return await thunkHandler(post("blog-services/tone/create", payload), thunkAPI);
});

export const UpdateTone = createAsyncThunk("/blog-services/tone/update/${id}", async (data, thunkAPI) => {
  let payload = {
    tone: data?.tone,
    description: data?.description,
  };
  return await thunkHandler(put(`/blog-services/tone/update?id=${data?.id}`, payload), thunkAPI);
});

export const updateStatusTone = createAsyncThunk("blog-services/tone/change-tone-status", async (data, thunkAPI) => {
  return await thunkHandler(
    put(`blog-services/tone/change-tone-status/${data?.id}`, {
      isActive: data?.isActive,
    }),
    thunkAPI
  );
});

const toneManagementSlice = createSlice({
  name: "ToneManagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTone.pending, (state, action) => {
        state.toneLoader = true;
      })
      .addCase(getTone.fulfilled, (state, action) => {
        state.toneData = action.payload.tones;
        state.toneCount = action.payload.counts;
        state.toneLoader = false;
      })
      .addCase(getTone.rejected, (state, action) => {
        state.toneData = [];
        state.toneLoader = false;
      });
  },
});

export default toneManagementSlice.reducer;
